import { useQuery } from '@tanstack/react-query';
import { functions } from '../../../firebase';

// Basic Trip interface, can be expanded based on actual data structure
export interface Trip {
  // Define properties of a trip based on what getGpsGateTrips returns
  // This is a placeholder, adjust according to the actual data model
  id: string;
  startTime: string;
  endTime: string;
  distance: number;
  from: string;
  to: string;
}

export default function useTrips({
  orgId,
  sensorId,
  date,
}: {
  orgId: string;
  sensorId: string;
  date: string;
}) {
  const {
    data: trips,
    isLoading: isTripsLoading,
    isError,
  } = useQuery<Trip[], Error>({
    queryKey: ['trips', orgId, sensorId, date],
    queryFn: async () => {
      const functionRef = functions.httpsCallable('settings');
      const response: any = await functionRef({
        requestType: 'GET_GPS_GATE_TRIPS',
        sensorId,
        orgId,
        date,
      });

      const errorCode = response?.data?.httpErrorCode?.status;
      if (errorCode) {
        console.error({ errorCode });
        throw new Error(`Error fetching trips: ${errorCode}`);
      }

      return response?.data || [];
    },
    enabled: !!orgId && !!sensorId && !!date, // Only run the query if all parameters are available
  });

  return { trips: trips ?? [], isTripsLoading, isError };
}
